<template>
  <va-modal
   v-model="showAuthModel"
   title="Login"
   size="medium"
   :noOutsideDismiss="true"
   :hideDefaultActions="true"
   :mobileFullscreen="true"
   message="Your session has expired, please sign in."
  >
  <template v-slot:default>
  <login-form></login-form>
  </template>
  </va-modal>
</template>

<script>

import Events from '@/app/events.js'
import AuthLoginForm from '@/components/auth/login/Login.vue'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

export default {
  name: 'app-auth-modal',
  components: {
    "login-form":AuthLoginForm
  },
  data () {
    return {
      showAuthModel: false
    }
  },

 methods: {

    ...mapState({
        user: state => state.user,
    }),

    ...mapGetters([
      'isAuthed'
    ]),

  },


  mounted(){

    Events.$on('auth-success', authSuccess => this.showAuthModel = false )
    Events.$on('auth-verify', authState => {

      if(this.$router.currentRoute.name == "login") return 

      if( typeof authState != "undefined" ){
        this.showAuthModel = Boolean(!authState)
      }

      return this.showAuthModel = this.isAuthed

    });

  }

}

</script>
